import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-title m-0" }
const _hoisted_6 = { class: "collapse show" }
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "row mb-6" }
const _hoisted_14 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_15 = { class: "col-lg-8 fv-row" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope fs-3" }, null, -1)
const _hoisted_32 = { class: "fv-plugins-message-container" }
const _hoisted_33 = { class: "fv-help-block" }
const _hoisted_34 = { class: "row mb-6" }
const _hoisted_35 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_36 = { class: "col-lg-8 fv-row" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone fs-3" }, null, -1)
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_41 = { class: "pb-5" }
const _hoisted_42 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_43 = { class: "row mb-6" }
const _hoisted_44 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_45 = { class: "col-lg-8 fv-row" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt fs-3" }, null, -1)
const _hoisted_47 = { class: "fv-plugins-message-container" }
const _hoisted_48 = { class: "fv-help-block" }
const _hoisted_49 = { class: "row mb-6" }
const _hoisted_50 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_51 = { class: "col-lg-8 fv-row" }
const _hoisted_52 = { class: "fv-plugins-message-container" }
const _hoisted_53 = { class: "fv-help-block" }
const _hoisted_54 = { class: "row mb-6" }
const _hoisted_55 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_56 = { class: "col-lg-8 fv-row" }
const _hoisted_57 = { class: "fv-plugins-message-container" }
const _hoisted_58 = { class: "fv-help-block" }
const _hoisted_59 = { class: "row mb-6" }
const _hoisted_60 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_61 = { class: "col-lg-8 fv-row" }
const _hoisted_62 = { class: "fv-plugins-message-container" }
const _hoisted_63 = { class: "fv-help-block" }
const _hoisted_64 = { class: "card mb-5 mb-xl-10" }
const _hoisted_65 = { class: "card-header border-0" }
const _hoisted_66 = { class: "card-title m-0" }
const _hoisted_67 = { class: "fw-bolder m-0" }
const _hoisted_68 = { class: "collapse show" }
const _hoisted_69 = { class: "card-body border-top p-9" }
const _hoisted_70 = { class: "row mb-6" }
const _hoisted_71 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_72 = { class: "col-lg-8 fv-row" }
const _hoisted_73 = { class: "fv-plugins-message-container" }
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = { class: "row mb-6" }
const _hoisted_76 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_77 = { class: "col-lg-8 fv-row" }
const _hoisted_78 = { class: "fv-plugins-message-container" }
const _hoisted_79 = { class: "fv-help-block" }
const _hoisted_80 = { class: "row mb-6" }
const _hoisted_81 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_82 = { class: "col-lg-8 fv-row" }
const _hoisted_83 = { class: "fv-plugins-message-container" }
const _hoisted_84 = { class: "fv-help-block" }
const _hoisted_85 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_86 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_87 = { class: "col-lg-8 fv-row" }
const _hoisted_88 = { class: "fv-plugins-message-container" }
const _hoisted_89 = { class: "fv-help-block" }
const _hoisted_90 = { class: "row mb-6" }
const _hoisted_91 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_92 = { class: "col-lg-8 fv-row" }
const _hoisted_93 = { class: "fv-plugins-message-container" }
const _hoisted_94 = { class: "fv-help-block" }
const _hoisted_95 = { class: "row mb-6" }
const _hoisted_96 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_97 = { class: "col-lg-8 fv-row" }
const _hoisted_98 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_99 = { class: "col-lg-10 fv-row fv-plugins-icon-container d-inline-block align-middle" }
const _hoisted_100 = ["download", "href"]
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","width":"100%","height":"100%","background":"#f5f7fa","color":"var(--el-text-color-secondary)","font-size":"10px"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    fill: "currentColor",
    class: "bi bi-filetype-pdf",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    })
  ])
], -1)
const _hoisted_102 = ["onClick"]
const _hoisted_103 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-trash-alt fs-1" }, null, -1)
const _hoisted_104 = [
  _hoisted_103
]
const _hoisted_105 = { class: "row mb-6" }
const _hoisted_106 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_107 = { class: "col-lg-8 fv-row" }
const _hoisted_108 = {
  class: "dropzone",
  id: "kt_dropzonejs_nuevos_documentosFamilia"
}
const _hoisted_109 = { class: "dz-message needsclick" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up text-primary fs-3x" }, null, -1)
const _hoisted_111 = { class: "ms-4" }
const _hoisted_112 = { class: "fs-5 fw-bolder text-gray-900 mb-1" }
const _hoisted_113 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_114 = { class: "card mb-5 mb-xl-10" }
const _hoisted_115 = { class: "card-header border-0" }
const _hoisted_116 = { class: "card-title m-0" }
const _hoisted_117 = { class: "fw-bolder m-0" }
const _hoisted_118 = { class: "collapse show" }
const _hoisted_119 = { class: "card-body border-top p-9" }
const _hoisted_120 = {
  key: 0,
  class: "separator separator-dashed my-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Menor = _resolveComponent("Menor")!
  const _component_ServiciosTabla = _resolveComponent("ServiciosTabla")!
  const _component_ServiciosColectivosTabla = _resolveComponent("ServiciosColectivosTabla")!
  const _component_Historico = _resolveComponent("Historico")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Page = _resolveComponent("Page")!
  const _component_CrearMenorModal = _resolveComponent("CrearMenorModal")!
  const _component_MenorServicioProgramadoModal = _resolveComponent("MenorServicioProgramadoModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Page, { showBack: "" }, {
      actions: _withCtx(() => [
        _createVNode(_component_el_dropdown, { class: "mx-3" }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#mau_modal_add_menor"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.añadirMenor")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  "data-bs-toggle": "modal",
                  "data-bs-target": "#mau_modal_menor_servicio_programado"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.añadirMenorServicioProgramado")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_divider, { class: "my-2" }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _ctx.eliminar,
                  disabled: _ctx.serviciosAprobados.length
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.eliminar")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "default" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.acciones.button")) + " ", 1),
                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_arrow_down)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onSubmit,
          loading: _ctx.guardaDetalle
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("formularios.profesionalDetalle.guardar.button")), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, { type: "border-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.datosSolicitanteGroup')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.$t("formularios.familiaDetalle.datosSolicitanteGroup")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.claseEstado)
                      }, _toDisplayString(_ctx.estado), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_el_select, {
                            name: "tratamiento",
                            class: "w-100",
                            modelValue: _ctx.tratamiento,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tratamiento) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tratamientos, (tratamiento, i) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: i,
                                  label: tratamiento.text,
                                  value: tratamiento.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_ErrorMessage, { name: "tratamiento" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("formularios.familiaDetalle.nombre.label")), 1),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_el_input, {
                                type: "text",
                                name: "nombre",
                                placeholder: " ",
                                modelValue: _ctx.nombre,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nombre) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_ErrorMessage, { name: "nombre" })
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_el_input, {
                                type: "text",
                                name: "apellidos",
                                placeholder: " ",
                                modelValue: _ctx.apellidos,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.apellidos) = $event))
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createVNode(_component_ErrorMessage, { name: "apellidos" })
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("formularios.familiaDetalle.dni.label")), 1),
                        _createElementVNode("div", _hoisted_25, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "dni",
                            placeholder: " ",
                            modelValue: _ctx.dni,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dni) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_ErrorMessage, { name: "dni" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("formularios.familiaDetalle.email.label")), 1),
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "email",
                            placeholder: " ",
                            modelValue: _ctx.email,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event))
                          }, {
                            append: _withCtx(() => [
                              _hoisted_31
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _createVNode(_component_ErrorMessage, { name: "email" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t("formularios.familiaDetalle.telefono.label")), 1),
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "telefono",
                            placeholder: " ",
                            modelValue: _ctx.telefono,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.telefono) = $event))
                          }, {
                            append: _withCtx(() => [
                              _hoisted_37
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_component_ErrorMessage, { name: "telefono" })
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_40,
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("h4", _hoisted_42, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccionGroup")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("formularios.familiaDetalle.direccion.label")), 1),
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "direccion",
                            placeholder: " ",
                            modelValue: _ctx.direccion,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.direccion) = $event))
                          }, {
                            append: _withCtx(() => [
                              _hoisted_46
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                              _createVNode(_component_ErrorMessage, { name: "direccion" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.$t("formularios.familiaDetalle.localidad.label")), 1),
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_el_input, {
                            type: "text",
                            name: "localidad",
                            placeholder: " ",
                            modelValue: _ctx.localidad,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localidad) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                              _createVNode(_component_ErrorMessage, { name: "localidad" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t("formularios.familiaDetalle.comarca.label")), 1),
                        _createElementVNode("div", _hoisted_56, [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.comarca,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.comarca) = $event)),
                            class: "w-100",
                            disabled: !_ctx.isAdmin
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: item.text,
                                  value: item.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"]),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _createVNode(_component_ErrorMessage, { name: "comarca" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.$t("formularios.familiaDetalle.provincia.label")), 1),
                        _createElementVNode("div", _hoisted_61, [
                          _createVNode(_component_el_select, {
                            name: "provincia",
                            placeholder: " ",
                            modelValue: _ctx.provincia,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.provincia) = $event)),
                            class: "w-100"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                label: "Huesca",
                                value: "Huesca"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Teruel",
                                value: "Teruel"
                              }),
                              _createVNode(_component_el_option, {
                                label: "Zaragoza",
                                value: "Zaragoza"
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _createVNode(_component_ErrorMessage, { name: "provincia" })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.situacionFamiliarGroup')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("h3", _hoisted_67, _toDisplayString(_ctx.$t("formularios.familiaDetalle.situacionFamiliarGroup")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tipologiaFamilia.label")), 1),
                        _createElementVNode("div", _hoisted_72, [
                          _createVNode(_component_el_select, {
                            name: "tipologiaFamilia",
                            class: "w-100",
                            modelValue: _ctx.tipologiaFamilia,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.tipologiaFamilia) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipologiasFamiliaTodas, (tipologiaFamilia, i) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: i,
                                  label: tipologiaFamilia.nombre,
                                  value: tipologiaFamilia.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createVNode(_component_ErrorMessage, { name: "tipologiaFamilia" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.$t("formularios.familiaDetalle.numeroMenores.label")), 1),
                        _createElementVNode("div", _hoisted_77, [
                          _createVNode(_component_el_select, {
                            name: "tipologiaFamilia",
                            class: "w-100",
                            modelValue: _ctx.numeroMenores,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.numeroMenores) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numeroMenoresOpcionesTodas, (numeroMenores, i) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: i,
                                  label: numeroMenores.nombre,
                                  value: numeroMenores.id
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("div", _hoisted_79, [
                              _createVNode(_component_ErrorMessage, { name: "numeroMenores" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.$t("formularios.familiaDetalle.conIngresos.label")), 1),
                        _createElementVNode("div", _hoisted_82, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.conIngresos,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.conIngresos) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _createVNode(_component_ErrorMessage, { name: "conIngresos" })
                            ])
                          ])
                        ])
                      ]),
                      (_ctx.conIngresos)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                            _createElementVNode("label", _hoisted_86, _toDisplayString(_ctx.$t("formularios.familiaDetalle.ingresos.label")), 1),
                            _createElementVNode("div", _hoisted_87, [
                              _createVNode(_component_CurrencyInput, {
                                modelValue: _ctx.ingresos,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.ingresos) = $event)),
                                modelModifiers: { lazy: true },
                                options: {
                      currency: 'EUR',
                      locale: 'es-ES',
                      currencyDisplay: 'symbol',
                      precision: 2,
                      hideCurrencySymbolOnFocus: true,
                      hideGroupingSeparatorOnFocus: true,
                      hideNegligibleDecimalDigitsOnFocus: true,
                      autoDecimalDigits: false,
                      useGrouping: true,
                      accountingSign: false,
                    },
                                type: "text",
                                name: "ingresos",
                                class: "form-control form-control-lg",
                                placeholder: "ej. 11000.21"
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("div", _hoisted_89, [
                                  _createVNode(_component_ErrorMessage, { name: "ingresos" })
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.$t("formularios.familiaDetalle.familiaPrioritaria.label")), 1),
                        _createElementVNode("div", _hoisted_92, [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.familiaPrioritaria,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.familiaPrioritaria) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_93, [
                            _createElementVNode("div", _hoisted_94, [
                              _createVNode(_component_ErrorMessage, { name: "familiaPrioritaria" })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("label", _hoisted_96, _toDisplayString(_ctx.$t("formularios.familiaDetalle.documentos.label")), 1),
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("ul", _hoisted_98, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentos, (file, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: i,
                                class: "el-upload-list__item is-success",
                                tabindex: "0"
                              }, [
                                _createElementVNode("div", _hoisted_99, [
                                  _createElementVNode("a", {
                                    class: "el-upload-list__item-name",
                                    download: `${_ctx.nombre}${_ctx.apellidos}${file.tipo}-${file.nombre}`,
                                    href: file.blob
                                  }, [
                                    _createVNode(_component_el_image, {
                                      class: "align-middle",
                                      style: {"width":"100px","height":"100px"},
                                      src: file.blob
                                    }, {
                                      error: _withCtx(() => [
                                        _hoisted_101
                                      ]),
                                      _: 2
                                    }, 1032, ["src"]),
                                    _createTextVNode(" " + _toDisplayString(file.nombre), 1)
                                  ], 8, _hoisted_100)
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "col-1 d-inline-block btn btn-color-primary btn-active-light-primary text-uppercase mb-5",
                                  onClick: ($event: any) => (_ctx.removeDocumento(i))
                                }, _hoisted_104, 8, _hoisted_102)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.$t("formularios.familiaDetalle.nuevosDocumentos.label")), 1),
                        _createElementVNode("div", _hoisted_107, [
                          _createElementVNode("div", _hoisted_108, [
                            _createElementVNode("div", _hoisted_109, [
                              _hoisted_110,
                              _createElementVNode("div", _hoisted_111, [
                                _createElementVNode("h3", _hoisted_112, _toDisplayString(_ctx.$t(
                              "formularios.familiaDetalle.nuevosDocumentos.accion"
                            )), 1),
                                _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.$t(
                            "formularios.familiaDetalle.nuevosDocumentos.descripcion"
                          )), 1)
                              ])
                            ])
                          ]),
                          _createVNode(_component_ErrorMessage, {
                            name: "certificadoAntecedentes",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.menoresFamilia')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                      _createElementVNode("h3", _hoisted_117, _toDisplayString(_ctx.$t("formularios.familiaDetalle.menoresGroup")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_118, [
                    _createElementVNode("div", _hoisted_119, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menoresFamilia, (menor, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          (i !== 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_120))
                            : _createCommentVNode("", true),
                          _createVNode(_component_Menor, { menor: menor }, null, 8, ["menor"])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.servicios'),
              lazy: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ServiciosTabla, { servicios: _ctx.menoresServicios }, null, 8, ["servicios"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.serviciosColectivos'),
              lazy: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ServiciosColectivosTabla, { servicios: _ctx.menoresServiciosColectivos }, null, 8, ["servicios"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_tab_pane, {
              label: _ctx.$t('formularios.familiaDetalle.historico.tab'),
              lazy: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Historico)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_CrearMenorModal),
    _createVNode(_component_MenorServicioProgramadoModal)
  ], 64))
}